import { message } from "antd";
import http from "../http";
import { getPostDetails } from "./postAction";

// Function
const getCommentsFunction = async (size = 100, page = 1, postId, commentId) => {
  const p = postId ? `&blogPostId=${postId}` : "";
  const c = commentId ? `&commentId=${commentId}` : "";
  return await http
    .get(`/comments?size=${size}&page=${page}` + p + c)
    .then(async (res) => {
      const data = await res.data.data;
      return data;
    })
    .catch((err) => {
      message.error(err.response?.data.message[0]);
      console.error(err);
      return {
        comments: [],
        count: 0,
      };
    });
};

const getComments = (size = 100, page = 1, postId, commentId) => {
  return async (dispatch) => {
    const data = await getCommentsFunction(size, page, postId, commentId);
    dispatch({
      type: "GET_COMMENTS",
      comments: data.comments,
      commentCount: data.count,
      commentCurrent: page,
    });
    return data;
  };
};

const postComment = (body) => {
  return (dispatch) => {
    return http
      .post(`/comments`, body)
      .then((res) => {
        message.success("Comment posted");
        dispatch(getPostDetails(false, body.blogPostId));
        return res.data.data;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
        return null;
      });
  };
};

//Function
const likeComment = (id) => {
  return http
    .put(`/comments/${id}/likes`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      message.error(err.response?.data.message[0]);
      console.error(err);
      return null;
    });
};

//Function
const unlikeComment = (id) => {
  return http
    .delete(`/comments/${id}/likes`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      message.error(err.response?.data.message[0]);
      console.error(err);
      return null;
    });
};

//Function
const flagComment = (id) => {
  return http
    .put(`/comments/${id}/flag`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      message.error(err.response?.data.message[0]);
      console.error(err);
      return null;
    });
};

//Function
const unflagComment = (id) => {
  return http
    .delete(`/comments/${id}/unflag`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      message.error(err.response?.data.message[0]);
      console.error(err);
      return null;
    });
};

export {
  getCommentsFunction,
  getComments,
  postComment,
  likeComment,
  unlikeComment,
  flagComment,
  unflagComment,
};
